// Convenience fee rounded to cents, same formula as finance_service getPaymentMethodInfoByOrg.
// A raw % fee (450 × 2.99% = 13.455) summed then toFixed'd shows 463.45 while BE/Stripe book 463.46.
export const convenienceFeeAmount = (info, base) =>
  info?.type === "%"
    ? Number(((+base || 0) * ((+info?.amount || 0) / 100)).toFixed(2))
    : +info?.amount || 0;
